import { AnswerStatuses } from '@tabeeb/enums'

export const answerStatuses = {
  Approved: AnswerStatuses.Approve,
  Submitted: AnswerStatuses.Pending,
  Rejected: AnswerStatuses.Reject,
}
